export const namespaced = true;

const getDefaultState = () => {
    return {
        webSocket: null,
        message: null,
        dialog: false,
        status: null,
    };
};
export const state = getDefaultState();

export const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    }, SET_WEB_SOCKET(state, webSocket) {
        state.webSocket = webSocket
    }, SET_MESSAGE(state, message) {
        state.message = message
    }, SET_DIALOG(state, dialog) {
        state.dialog = dialog
    }, SET_STATUS(state, status) {
        state.status = status
    }
}
export const actions = {
    resetState({commit}) {
        commit("resetState");
    },
    setDialog({commit}, bool) {
        commit("SET_DIALOG", bool);
    },
    setWebSocket(context, projectId) {
        let endPoint = `ws/upload_to_blob/${projectId}/`
        let baseUrl = import.meta.env.VITE_APP_API_BASE_URL.split('//')[1]
        let connectionString = `${context.getters.webSocketPrefix}://${baseUrl}${endPoint}`;
        let webSocket = new WebSocket(connectionString);
        webSocket.onmessage = async (e) => {
            let data = JSON.parse(e.data)
            if (data.type === 'upload') {
                if ('done' in data.message) {
                    if (data.message.done) {
                        context.commit('SET_DIALOG', true)
                        context.commit('SET_MESSAGE', data.message.done)
                        await context.dispatch('project/setUploadingDikeProfiles', false, {root: true});
                    }
                } else if ('status' in data.message) {
                    context.commit('SET_STATUS', data.message.status)
                } else if ('2D_creation_done' in data.message) {
                    await context.dispatch('dikeProfiles/fetchAll', projectId, {root: true});
                }
            }
            if (data.type === 'connection_established') {
                console.log('connection: ', data.message)
            }
        }
        webSocket.onerror = function (e) {
            console.log("self.socket error", e);
        };
        webSocket.onclose = function () {
            console.log("Websocket connection closed.");
        }
        context.commit('SET_WEB_SOCKET', webSocket)
    }
}


export const getters = {
    webSocketPrefix: () => {
        return import.meta.env.MODE !== 'development' ? 'wss' : 'ws'
    },
};




